import { createSlice } from '@reduxjs/toolkit';

export const ClickOutsideSlice = createSlice({
  name: 'clickOutside',
  initialState: {
    isClickedOutside: false,
  },
  reducers: {
    setIsClickedOutSide: (state, { payload }) => {
      state.isClickedOutside = payload;
    },
  },
});

export const isClickedOutsideSelector = state =>
  state.clickOutside.isClickedOutside;

export const { setIsClickedOutSide } = ClickOutsideSlice.actions;

export default ClickOutsideSlice.reducer;
